import rootService from 'core/services.root';

export default rootService({
    deleteControl: ['DELETE', '/control/delete/:id'],
    deletePolyOffice: ['DELETE', '/polyoffice/delete/:id'],
    deleteSpecialty: ['DELETE', '/specialty/delete/:id'],
    fetchAreas: ['GET', '/area/all'],
    fetchCampaignTypes: ['GET', '/campaign/type/all'],
    fetchCompanies: ['GET', '/company/all'],
    fetchControlTypes: ['GET', '/control/type/all'],
    fetchControlTypesDetail: ['GET', '/control/type/all/details'],
    fetchControls: ['GET', '/control/all'],
    fetchCostCenters: ['GET', '/cost-center/all'],
    fetchPlans: ['GET', '/medical-coverage/:coverage_id/plans'],
    fetchPositions: ['GET', '/position/all'],
    fetchRiskAgent: ['GET', '/risk-agent/:id'],
    fetchRiskAgentTypes: ['GET', '/risk-agent/type/all'],
    fetchRiskAgents: ['GET', '/risk-agent/all'],
    fetchSpecialties: ['GET', '/specialty/list'],
    fetchVaccineDoses: ['GET', '/vaccine/:id'],
    fetchVaccines: ['GET', '/vaccine/listing'],
    fetchWorkplaces: ['GET', '/workplace/all?show_all=true'],
    getAllCities: ['GET', '/city/province/:id'],
    getAllCoverages: ['GET', '/medical-coverage/all'],
    getAllDistricts: ['GET', '/district/city/:id'],
    getAllEnrollments: ['GET', '/enrollment/all'],
    getAllOffices: ['GET', '/office/all'],
    getAllPatients: ['GET', '/patient/listing'],
    getAllPolyOffices: ['GET', '/polyoffice/listing'],
    getAllProfessionals: ['GET', '/doctor/listing'],
    getAllProvinces: ['GET', '/province/all'],
    getAllSymptoms: ['GET', '/symptom/all'],
    postArea: ['POST', '/area/store'],
    postCompany: ['POST', '/company/store'],
    postControl: ['POST', '/control/store'],
    postCostCenter: ['POST', '/cost-center/store'],
    postPolyOffice: ['POST', '/polyoffice/store'],
    postPosition: ['POST', '/position/store'],
    postRiskAgent: ['POST', '/risk-agent/store'],
    postSpecialty: ['POST', '/specialty/store'],
    postWorkplace: ['POST', '/workplace/store'],
    putArea: ['PUT', '/area/update/:id'],
    putCampaignType: ['PUT', '/campaign/type/update/:id'],
    putCompany: ['PUT', '/company/update/:id'],
    putControl: ['PUT', '/control/update/:id'],
    putCostCenter: ['PUT', '/cost-center/update/:id'],
    putPolyOffice: ['PUT', '/polyoffice/update/:id'],
    putPosition: ['PUT', '/position/update/:id'],
    putRiskAgent: ['PUT', '/risk-agent/update/:id'],
    putSpecialty: ['PUT', '/specialty/update/:id'],
    putWorkplace: ['PUT', '/workplace/update/:id']
});
